import {
    SET_INVITE_FRIEND_STATUS,
    SET_INVITE_FRIEND_ADDRESS,
    SET_REFERRAL_CODE,
    SET_REFERRAL_BALANCE, SET_REFERRAL_BENEFICIARIES
} from "../actions/constants";
import {createReducer} from "../../../_common/common.ts";


export const inviteFriendStatus = createReducer({status: null, address: null, code: null, balance: null, beneficiaries: null}, {
    [SET_INVITE_FRIEND_STATUS]: (state, status)=> {
        state.status = status;
        return state;
    },
    [SET_INVITE_FRIEND_ADDRESS]: (state, address)=>{
        state.address = address;
        return state
    },
    [SET_REFERRAL_CODE]: (state, code) => {
        state.code = code;
        return state;
    },
    [SET_REFERRAL_BALANCE]: (state, balance) => {
        state.balance = balance;
        return state;
    },
    [SET_REFERRAL_BENEFICIARIES]: (state, beneficiaries) => {
        state.beneficiaries = beneficiaries;
        return state;
    },
});
